import React from "react";
import { Grid, GridProps } from "@material-ui/core";

export type ProductListProps = {} & React.HTMLAttributes<HTMLUListElement> & GridProps;

export const ProductList = ({ children, ...props }: ProductListProps) => {
  return (
    <Grid {...props} container spacing={5}>
      {children}
    </Grid>
  )
};
